export const sidebarConstants = {
    DEFAULT_MODES: ['personal', 'shared', 'business', 'notification_list'],

    // Action Types
    SET_ORGANIZATION: 'SET_ORGANIZATION',
    SET_TAB: 'SET_TAB',
};
